export default {"theme":{"themes":{"light":{"primary":{"base":"#6200EA"}}}}}
